import { useTranslation } from 'react-i18next';

import type { DocsOperation, DocsParam } from '../../generated/reference';
import { ParamTable } from '../param-table';

import { EndpointSection } from './endpoint-section';

const LOCATIONS = ['path', 'query', 'header'] as const satisfies Array<DocsParam['in']>;

/** One table per parameter location that the operation uses. */
export function EndpointParameters({ operation }: { operation: DocsOperation }) {
  const { t } = useTranslation('docs');
  return LOCATIONS.map((location) => {
    const params = operation.parameters.filter((param) => param.in === location);
    if (params.length === 0) return null;
    const title = t(`endpoint.parameters.${location}`);
    return (
      <EndpointSection key={location} id={`${location}-parameters`} title={title}>
        <ParamTable params={params} label={title} />
      </EndpointSection>
    );
  });
}
